import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Dropdown, MenuItem } from 'react-bootstrap'

import { options as optionsFor } from './options'

class ExportButton extends Component {
  constructor(props) {
    super(props)
    this.state = { ids: [] }
    this.handleOnSelect = this.handleOnSelect.bind(this)
  }

  handleOnSelect(key) {
    this.setState(
      (prevState, props) => {
        return {
          ids: props.ids,
        }
      },
      () => {
        this.exportForm.convert.setAttribute('value', key)
        this.exportForm.target = '_self';
        if (key === 'BD') this.exportForm.action = '/batchdownload/hitlist'
        else if (key === 'CM') this.exportForm.action = '/cgi-bin/fbrf2ris.cgi'
        else if (key === 'RS') this.exportForm.action = '/ribbonstack'
        else if (key === 'FM') this.exportForm.action = '/featuremapper/hitlist'
        else if (key === 'HL') this.exportForm.action = '/hitlist'
        else if (key === 'GE') {
          this.exportForm.action = 'https://www.flyrnai.org/tools/pangea/web/home/7227';
          this.exportForm.target = '_blank';
        }
        else if (key === 'SD') this.exportForm.action = '/download/sequence/batch/'
        else this.exportForm.action = '/cgi-bin/export2batch.pl'
        this.exportForm.submit()
      }
    )
  }

  render() {
    const dsbld = this.props.dataClasses.length !== 1 ? true : false
    const title =
      this.props.dataClasses.length > 1
        ? '      Exports only available for single data class (filtered) lists'
        : ''
    const dc =
      this.props.dataClasses.length > 0
        ? this.props.dataClasses[0].toLowerCase()
        : '-'

    // Check if selected data class is sequenced related or not.
    const isSeqDc =
      ['fbgn', 'fbtr', 'fbpp', 'fbsf', 'fbcl', 'fbtp'].findIndex(
        (seqDc) => seqDc === dc
      ) !== -1

    // Only update the form DOM when the state changes, not the props.

    /*  Generate hidden input fields from the IDs in state.
        If you do this directly from the props, there is a noticeable
        lag in the UI when a user switches between views.
        This approach that uses props and state eliminates that. */

    const { ids } = this.state
    const idInputs = ids.map((id, i) => (
      <input type="hidden" key={id + i} name="ids" value={id} readOnly />
    ))
    let opts = optionsFor[dc] || {}

    var otherFileOptions = []
    if (opts.hasOwnProperty('file')) {
      otherFileOptions = opts['file'].map((opt, i) => (
        <MenuItem key={opt.action} eventKey={opt.action}>
          &emsp;
          {opt.optionName}
        </MenuItem>
      ))
    }
    var DBlinkOptions = [] // genes, alleles, etc. have a few extras under 'HitList Conversion Tools' on the old site
    if (opts.hasOwnProperty('DBlinks')) {
      DBlinkOptions = opts['DBlinks'].map((opt, i) => (
        <MenuItem key={opt.convert} eventKey={opt.convert}>
          &emsp;
          {opt.optionName}
        </MenuItem>
      ))
      DBlinkOptions.unshift(
        <MenuItem
          key="DBlinksHeader"
          header
          style={{ fontStyle: 'italic', color: 'steelblue' }}>
          <b>external database links (for associated genes):</b>
        </MenuItem>
      )
    }
    var extLinkOptions = []
    extLinkOptions.push(
          <MenuItem key="extLinksHeader" header style={{ fontStyle: 'italic', color: 'steelblue' }}>
            <b>selected items to an external tool:</b>
          </MenuItem>
    )
    if (dc==='fbgn') { extLinkOptions.push(
          <MenuItem eventKey="GE">&emsp;PANGEA Enrichment Tool <span title="PAthway, Network and Gene-set Enrichment Analysis tool at the Drosophila RNAi Screening Center">(DRSC <i class="fa fa-external-link"></i>)</span></MenuItem>
    )}
    /* Put the form between the Dropdown.Toggle and the DropdownMenu so that it doesn't fool the
           Bootstrap btn-group into thinking there is another child before (or after) this button.
           (May become moot if I stop grouping the buttons. Which I have.) */

    /* values for hidden params 'ids' and 'convert' will be set by handleOnSelect */

    return (
      <Dropdown
        id="hitlist-export"
        onSelect={this.handleOnSelect}
        disabled={dsbld}
        title={title}>
        <Dropdown.Toggle bsStyle="primary">Export</Dropdown.Toggle>
        <form
          method="post"
          action="/cgi-bin/export2batch.pl"
          ref={(form) => (this.exportForm = form)}>
          <input type="hidden" key="mode" name="mode" value="convert" />
          <input type="hidden" key="convert" name="convert" value="" />
          <input type="hidden" key="caller" name="caller" value="hitlist" />
          {idInputs}
        </form>
        <Dropdown.Menu>
          <MenuItem header style={{ fontStyle: 'italic', color: 'steelblue' }}>
            <b>selected items to a FlyBase tool:</b>
          </MenuItem>
          {/** Only show for sequence related data classes */}
          {isSeqDc && (
            <MenuItem eventKey="SD">&emsp;Sequence Downloader</MenuItem>
          )}
          {/** Only show for Genes data class */}
          { (dc==='fbgn') && (
            <MenuItem eventKey="RS">&emsp;GO Ribbon Stack Viewer</MenuItem>
          )}
          <MenuItem eventKey="BD">&emsp;Batch Download</MenuItem>
          <MenuItem eventKey="QB">&emsp;QueryBuilder</MenuItem>
          <MenuItem eventKey="FM">&emsp;FeatureMapper</MenuItem>
          <MenuItem header style={{ fontStyle: 'italic', color: 'steelblue' }}>
            <b>selected items as a file:</b>
          </MenuItem>
          {otherFileOptions}
          <MenuItem eventKey="tofile">&emsp;ID list (download)</MenuItem>
          <MenuItem eventKey="crossrefs">
            &emsp;FlyBase records crossreferencing table
          </MenuItem>
          {DBlinkOptions}
          {/** Only show for Genes data class */}
          { (dc==='fbgn') && (extLinkOptions) }
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}

ExportButton.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.string),
}

ExportButton.defaultProps = {
  ids: [],
}

export default ExportButton
